import { action, observable } from 'mobx';

import {
  dateIsGreaterThan7Days,
  dateIsGreaterThanNDays,
} from '../utils/DateUtils';
import {
  CALENDAR_DISPLAY,
  CALENDAR_DISPLAY_2025,
  NNLXMAS2025_DISPLAY,
} from '../constants/modals';
import { getCookie, isNakedNewsLiveDomain } from '../utils/helpers';
import { getModalsData } from '../components/App/services';

import AnchorStore from './AnchorStore';

const PAGE_TO_HIDE_NICKNAME_POPUP = [
  '/terms_of_service',
  '/privacy_policy',
  '/cookie-policy',
];

class ModalStore {
  @observable showEmailModal = false;
  @observable nicknameCheckDone = false;
  @observable showNicknameCollectModal = false;
  @observable showAgeVerificationModal = false;
  @observable modalsData = [];
  @observable showCalendarModal = false;
  @observable timeout = null;
  @observable showNNLPromoModal = false;

  @action
  clearTimeout = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  @action
  fetchModalsData = async (authenticated) => {
    if (authenticated) {
      const { data: modalsResponse } = await getModalsData();
      this.modalsData = modalsResponse.data;
    }
  };

  @action
  setShowEmailModal = (value) => {
    this.showEmailModal = value;
  };

  @action
  setShowNicknameCollectModal = (value) => {
    this.showNicknameCollectModal = value;
  };

  @action
  setShouldShowCalendarModal = (value) => {
    this.showCalendarModal = value;
  };

  @action
  setShouldShowNNLPromoModal = (value) => {
    this.showNNLPromoModal = value;
  };

  @action
  setShouldShowAgeVerificationModal = (value) => {
    this.showAgeVerificationModal = value;
  };

  @action
  handleCalendarPromoModal = (user, location) => {
    const { pathname } = location || {};
    const lastShown = localStorage.getItem('CALENDAR_MODAL_SHOWN');
    const lastShownTime = lastShown ? parseInt(lastShown, 10) : 0;
    const notShownRecently = dateIsGreaterThan7Days(lastShownTime);

    if (
      getCookie(CALENDAR_DISPLAY_2025) ||
      !notShownRecently ||
      !this.shouldNotShowAgeVerificationModal(user) ||
      !user?.features.includes('CALENDAR_2021') ||
      !user?.features.includes('SHOW_SHOP_LINK')
    ) {
      return;
    }

    this.timeout = setTimeout(() => {
      const modal = this.modalsData.find(
        (el) => el.modalType === CALENDAR_DISPLAY
      );
      const exceptions = [
        '/account/purchase',
        '/calendar-purchase',
        '/calendar-checkout',
        '/oauth2/login',
      ];

      const isAnchorPageOrAnchorIsLive =
        /(^\/naked-news-anchor-)/.test(pathname) &&
        (AnchorStore.isAnchorLive || AnchorStore.isAnchorLive === undefined);
      const shouldntShowModal =
        exceptions.includes(pathname) ||
        isAnchorPageOrAnchorIsLive ||
        (!user.authenticated && getCookie(CALENDAR_DISPLAY_2025)) ||
        (user.authenticated &&
          modal &&
          !modal.showModal &&
          !dateIsGreaterThan7Days(modal?.viewedAt)) ||
        !notShownRecently;

      if (!shouldntShowModal) {
        this.setShouldShowCalendarModal(true);

        localStorage.setItem('CALENDAR_MODAL_SHOWN', Date.now().toString());
      }
    }, 5000);
  };

  @action
  handleNNLMembersPromoModal = (user, location) => {
    const { pathname } = location || {};
    const lastShown = localStorage.getItem('NNL_PROMO_MODAL_2025');
    const lastShownTime = lastShown ? parseInt(lastShown, 10) : 0;
    const notShownRecently = dateIsGreaterThanNDays(lastShownTime, 1);

    if (
      getCookie(NNLXMAS2025_DISPLAY) ||
      !notShownRecently ||
      !this.shouldNotShowAgeVerificationModal(user)
    ) {
      return;
    }

    this.timeout = setTimeout(() => {
      const modal = this.modalsData.find(
        (el) => el.modalType === NNLXMAS2025_DISPLAY
      );
      const exceptions = [
        '/account/purchase',
        '/calendar-purchase',
        '/calendar-checkout',
        '/oauth2/login',
      ];

      const isAnchorPageOrAnchorIsLive =
        /(^\/naked-news-anchor-)/.test(pathname) &&
        (AnchorStore.isAnchorLive || AnchorStore.isAnchorLive === undefined);
      const shouldntShowModal =
        exceptions.includes(pathname) ||
        isAnchorPageOrAnchorIsLive ||
        (!user.authenticated && getCookie(NNLXMAS2025_DISPLAY)) ||
        (user.authenticated &&
          modal &&
          !modal.showModal &&
          !dateIsGreaterThan7Days(modal?.viewedAt)) ||
        !notShownRecently;

      if (!shouldntShowModal) {
        this.setShouldShowNNLPromoModal(true);

        localStorage.setItem('NNL_PROMO_MODAL_2025', Date.now().toString());
      }
    }, 5000);
  };

  @action
  setShowNicknameCollectModal = (value) => {
    this.showNicknameCollectModal = value;
  };

  @action
  checkIfUserShouldUpdateNickname = (user, location) => {
    if (PAGE_TO_HIDE_NICKNAME_POPUP?.includes(location?.pathname)) {
      this.setShowNicknameCollectModal(false);

      return;
    }

    if (
      user?.account?.nicknameUpdateCounter === 0 &&
      user?.account?.createdDuringCombinedPromoEvent
    ) {
      this.setShowNicknameCollectModal(true);
    }

    this.nicknameCheckDone = true;
  };

  shouldNotShowAgeVerificationModal = (user) =>
    user?.authenticated ||
    getCookie('AGE_VERIFICATION')?.length > 0 ||
    !isNakedNewsLiveDomain;

  @action
  handleAgeVerificationModal = (user) => {
    if (this.shouldNotShowAgeVerificationModal(user)) {
      return;
    }

    this.showAgeVerificationModal = true;
    this.showCalendarModal = false;
  };
}

export default new ModalStore();
